import { Component, Input, OnInit } from '@angular/core';
import { CustomButtonActionService } from 'custom-button-action';
import { take } from 'rxjs/operators';
import { FormDesignerService } from '../../form-designer/form-designer.service';

@Component({
  selector: 'app-fb-dashboard-quick-access',
  templateUrl: './fb-dashboard-quick-access.component.html',
  styleUrls: ['./fb-dashboard-quick-access.component.scss']
})
export class FbDashboardQuickAccessComponent implements OnInit {
  @Input() content: {
    type: string,
    title: string,
    redirectionDetails: any
  };
  currentCreateReqImage = 'assets/images/CreateReq.svg';
  currentPostJobImage = 'assets/images/PostJob.svg';
  currentInterviewProcessImage = 'assets/images/InterviewProcess.svg';

  constructor(
    private customButtonActionService: CustomButtonActionService,
    private formDesignerService: FormDesignerService
  ) { }

  ngOnInit() {
  }

  onMouseOver(imageType: string) {
    switch (imageType) {
      case 'CreateReq':
        this.currentCreateReqImage = 'assets/images/CreateReq-white.svg';
        break;
      case 'PostJob':
        this.currentPostJobImage = 'assets/images/PostJob-white.svg';
        break;
      case 'InterviewProcess':
        this.currentInterviewProcessImage = 'assets/images/InterviewProcess-white.svg';
        break;
    }
  }

  onMouseOut(imageType: string) {
    switch (imageType) {
      case 'CreateReq':
        this.currentCreateReqImage = 'assets/images/CreateReq.svg';
        break;
      case 'PostJob':
        this.currentPostJobImage = 'assets/images/PostJob.svg';
        break;
      case 'InterviewProcess':
        this.currentInterviewProcessImage = 'assets/images/InterviewProcess.svg';
        break;
    }
  }

  onRedirect(type: string) {
    const pageFormId = this.content.redirectionDetails?.[type];
    if (pageFormId) {
      this.customButtonActionService.getPageFormById(pageFormId)
        .pipe(take(1))
        .subscribe((response: any) => {
          if (response) {
            if (response.menuId) {
              this.formDesignerService.activateMenuAndOpenPage.next(response.menuId);
            } else {
              const item = {
                formType: response.buildFormatTypeId,
                pageFormId: response.id
              }
              this.customButtonActionService.onLinkRedirectPageSubject.next(item);
            }
          }
        });
    }
  }

}
